const url = '/qianwei'

module.exports = {
    url
}